import { Component } from '@angular/core';

@Component({
    selector: 'app-mobile-not-supported-page',
    templateUrl: './mobile-not-supported-page.component.html',
    styleUrls: ['./mobile-not-supported-page.component.css'],
})
export class MobileNotSupportedPageComponent {
    constructor() {}
}
